import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-course-listings',
  templateUrl: './course-listings.component.html',
  styleUrls: ['./course-listings.component.css'],
})
export class CourseListingsComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  navigate_to_course(page: number) {
    this.router.navigate(['/courses'], {
      queryParams: { page },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/course-listings/course-listings.component.ts